<template>
<page-template>

  <div class="inside-wrapper" v-if="isShow">

    <div class="setting-item-wrapper">

      <common-service-policy :pickup-order-limit="editable.pickupOrderLimit"
                             :pickup-order-items-limit="editable.pickupOrderItemsLimit"
                             :sold-out-limit="editable.soldOutLimit"
                             :order-soon-limit="editable.orderSoonLimit"
                             @onChangePickupOrderList="value => editable.pickupOrderLimit = value"
                             @onChangePickupOrderItemsLimit="value => editable.pickupOrderItemsLimit = value"
                             @onChangeSoldOutLimit="value => editable.soldOutLimit = value"
                             @onChangeOrderSoonLimit="value => editable.orderSoonLimit = value"/>

      <winestore-policy :wp-noshow-limit-days="editable.wpNoshowLimitDays"
                        :wp-cutoff-hour-list="editable.wpCutoffHourList"
                        @onChangeWpNoshowLimitDays="value => editable.wpNoshowLimitDays = value"
                        @onChangeWpCutoffHourList="value => editable.wpCutoffHourList = value"/>

      <e24-policy :e24-order-cutoff-hour="editable.e24OrderCutoffHour"
                  :e24-noshow-limit-days="editable.e24NoshowLimitDays"
                  :e24-delivery-delay-days="editable.e24DeliveryDelayDays"
                  :e24-cancel-cutoff-hour="editable.e24CancelCutoffHour"
                  @onChangeE24OrderCutoffHour="value => editable.e24OrderCutoffHour = value"
                  @onChangeE24NoshowLimitDays="value => editable.e24NoshowLimitDays = value"
                  @onChangeE24DeliveryDelayDays="value => editable.e24DeliveryDelayDays = value"
                  @onChangeE24CancelCutoffHour="value => editable.e24CancelCutoffHour = value">

      </e24-policy>

      <system-setting :android-min-version="editable.androidMinVersion"
                      :android-current-version="editable.androidCurrentVersion"
                      :ios-min-version="editable.iosMinVersion"
                      :ios-current-version="editable.iosCurrentVersion"
                      @onChangeAndroidMinVersion="value => editable.androidMinVersion = value"
                      @onChangeAndroidCurrentVersion="value => editable.androidCurrentVersion = value"
                      @onChangeIosMinVersion="value => editable.iosMinVersion = value"
                      @onChangeIosCurrentVersion="value => editable.iosCurrentVersion = value"/>

    </div>

    <layout-button-text :is-type="1" class="change-button" title="변경" :callback="insertServiceConfig"/>

  </div>
</page-template>
</template>

<script>
import PageTemplate from '@/spa/components/page-template/PageTemplate';
import LayoutButtonText from '@/spa/components/LayoutButtonText';

import CommonServicePolicy from './category/CommonServicePolicy';
import WinestorePolicy from './category/WinestorePolicy';
import E24Policy from './category/E24Policy';
import SystemSetting from './category/SystemSetting';

export default {
  name: 'BoardService',
  components: {
    PageTemplate,

    CommonServicePolicy,
    WinestorePolicy,
    E24Policy,
    SystemSetting,

    LayoutButtonText,
  },
  methods: {
    async insertServiceConfig() {
      const result = await this.$store.dispatch('createServiceConfig', this.editable);

      if (result.response) this.editable = this.normalizeServiceConfig(result.response);
      this.$toast(result.message);
    },

    normalizeServiceConfig(serviceConfig) {
      return {
        pickupOrderLimit: parseInt(serviceConfig.pickup_order_limit, 10) || 0,
        pickupOrderItemsLimit: parseInt(serviceConfig.pickup_order_items_limit, 10) || 0,
        soldOutLimit: parseInt(serviceConfig.sold_out_limit, 10) || 0,
        orderSoonLimit: parseInt(serviceConfig.order_soon_limit, 10) || 0,

        wpNoshowLimitDays: parseInt(serviceConfig.wp_noshow_limit_days, 10) || 0,
        wpCutoffHourList: !serviceConfig.wp_cutoff_hour_list ? {
          order_cutoff_hour: 0,
          cancel_cutoff_hour: 0,
        } : serviceConfig.wp_cutoff_hour_list,

        e24NoshowLimitDays: parseInt(serviceConfig.e24_noshow_limit_days, 10) || 0,
        e24CancelCutoffHour: parseInt(serviceConfig.e24_cancel_cutoff_hour, 10) || 0,
        e24OrderCutoffHour: parseInt(serviceConfig.e24_order_cutoff_hour, 10) || 0,
        e24DeliveryDelayDays: parseInt(serviceConfig.e24_delivery_delay_days, 10) || 0,

        androidMinVersion: parseInt(serviceConfig.android_min_version, 10) || 0,
        androidCurrentVersion: parseInt(serviceConfig.android_current_version, 10) || 0,
        iosMinVersion: parseInt(serviceConfig.ios_min_version, 10) || 0,
        iosCurrentVersion: parseInt(serviceConfig.ios_current_version, 10) || 0,
      };
    },
  },

  async created() {
    const serviceConfigs = await this.$store.dispatch('getServiceConfig');

    if (serviceConfigs.response) this.editable = this.normalizeServiceConfig(serviceConfigs.response[0]);

    this.isShow = true;
    this.$toast(serviceConfigs.message);
  },

  data() {
    return {
      editable: {
        pickupOrderLimit: 0,
        pickupOrderItemsLimit: 0,
        soldOutLimit: 0,
        orderSoonLimit: 0,

        wpNoshowLimitDays: 0,
        wpCutoffHourList: [],

        e24NoshowLimitDays: 0,
        e24CancelCutoffHour: 0,
        e24OrderCutoffHour: 0,
        e24DeliveryDelayDays: 0,

        androidMinVersion: 0,
        androidCurrentVersion: 0,
        iosMinVersion: 0,
        iosCurrentVersion: 0,
      },

      isShow: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.inside-wrapper {
  width: 90%;
  height: auto;

  margin: 0 auto;
  margin-top: 20px;

  padding-top: 20px;
  padding-bottom: 20px;

  background-color: #fff;

  .setting-item-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    flex-direction: column;

    flex-wrap: wrap;
  }

  .change-button {
    margin-top: 50px;
    width: 150px;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/service/BoardService.vue